import { render, staticRenderFns } from "./OrderDeliveryPrice.vue?vue&type=template&id=fe5c2df4&scoped=true&"
import script from "./OrderDeliveryPrice.vue?vue&type=script&async=true&lang=js&"
export * from "./OrderDeliveryPrice.vue?vue&type=script&async=true&lang=js&"
import style0 from "./OrderDeliveryPrice.vue?vue&type=style&index=0&id=fe5c2df4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5c2df4",
  null
  
)

export default component.exports